import Aos from "aos"
import {Tab, Popover} from "bootstrap"

function changeTab(event) {
  let opt = event.options[event.selectedIndex]
  let tabSelected = opt.dataset.bsTarget
  $("[data-bs-target='" + tabSelected + "']").click()
}

let counter = 0

function add(id, text, selectID) {
  if (!id.trim()) {
    return
  }

  const element = document.createElement("option")

  element.setAttribute("role", "tab")
  element.setAttribute("aria-controls", id)
  element.setAttribute("data-bs-target", "#" + id)
  element.setAttribute("value", id)
  element.textContent = text

  const filterButtons = document.getElementById(selectID)

  filterButtons.appendChild(element)
  counter++
}
$(".tab-url .nav-tabs").on("click", function () {
  let tab_ = $(this).attr("aria-controls")
  history.replaceState(null, null, "?tab=" + tab_)
  Aos.refreshHard()
})

$(".tab-status .nav-link").on("click", function () {
  $(this).addClass("visited")
})

var triggerTabList = [].slice.call(document.querySelectorAll(".tabContent button"))
triggerTabList.forEach(function (triggerEl) {
  var tabTrigger = new Tab(triggerEl)
})

const urlParams = new URLSearchParams(window.location.search)
const tabId = urlParams.get("tab")
const rowId = urlParams.get("row")

if (tabId) {
  var triggerEl = document.querySelector(`button[data-bs-target ="#${tabId}"]`)

  Tab.getInstance(triggerEl).show() // Select tab by name

  // Scrool to section
  if (rowId) {
    const yOffset = -210
    const element = document.querySelector(`#${tabId}.active .tab-row:nth-child(${rowId})`)
    const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset

    window.scrollTo({top: y, behavior: "smooth"})
  } else {
    const yOffset = -164
    const element = document.getElementById(tabId)
    const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset

    window.scrollTo({top: y, behavior: "smooth"})
  }
}

window.addEventListener("load", () => {
  let allTabs = document.getElementsByClassName("tabContent")

  for (var i = 0; i < allTabs.length; i++) {
    let tabID = allTabs[i].id
    let selectID = allTabs[i].getAttribute("data-select")

    $("#" + tabID + " > li > button").each(function (index, elm) {
      add($(elm).attr("aria-controls"), $(elm).attr("aria-label"), selectID)
    })
    // if (tabId) {
    //   $(selectID).val(tabId)
    // }
  }

  $(".detail-popover").on("click", function (e) {
    if (this.classList.contains("popover-open")) {
      $(this).toggleClass("popover-open")
      $(":focus").blur()
    } else {
      $(this).addClass("popover-open")
    }
    e.preventDefault()
  })

  $(".detail-popover").on("focusout", function (e) {
    if (this.classList.contains("popover-open")) {
      $(this).toggleClass("popover-open")
      const popoverBtn = Popover.getInstance(this)
      popoverBtn.hide()
    }
    e.preventDefault()
  })
})

window.changeTab = changeTab
